import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TeamType } from "../../services/api/types/Teams";
import { useTeamTypesArray } from "../../services/hooks/TeamTypeList";

interface TeamTypeState {
  teamTypes: Array<TeamType>;
}

const initialState: TeamTypeState = {
  teamTypes: [],
};

export const teamTypeSlice = createSlice({
  name: "MemberList",
  initialState,
  reducers: {
    pullTeamTypes: state => {
      state.teamTypes = useTeamTypesArray();
    },
    setTeamTypes: (state, action: PayloadAction<Array<TeamType>>) => {
      state.teamTypes = action.payload;
    },
  },
});

export const { setTeamTypes, pullTeamTypes } = teamTypeSlice.actions;
